{"domain":"inglis-dev.au.auth0.com","clientId":"f6Un7NALdhL73UOFzdj7oIbbqfJfLzX6","audience":"https://api.staging.vendor.inglis.com.au"}